<template> 
	<div>
		<section id="content">
			<div class="container">
				<br/>
				<article class="message is-info">
					<div class="message-body">
						<template v-if="grouptype == 'elected'">
							<p>Pursuant to Section 63 of the Local Government Act 1999:-</p>
							<ol style="padding: 0 2em;">
							<li>”The Governor may, by regulation, prescribe a code of conduct to be observed by the members of all Councils."</li>
							<li>Council Members must observe the code of conduct."</li>
							</ol>
						</template>
						<template v-else>
							<p>Pursuant to Section 110(1) of the Local Government Act 1999 the Code of Conduct for Employees became operational as from 13 February 2014. The Code of Conduct stipulates that a Gifts and Benefits register is to be maintained by the Council's Chief Executive Officer and updated quarterly.</p>
						</template>
					</div>
				</article>

                <article class="message is-warning" v-if="!valueYear[1]">
                    <div class="message-body"><strong>Data Load Error Detected!</strong><br/>You may need to 
                        <a v-on:click.stop.prevent="reload">reload</a> 
                    the data, or use a different browser if the problem persists.</div>
                </article>


				<!-- NEW COMPONENT HERE -->
				<div class="filter is-mobile">

					<h2>Search Form</h2>

                    <label>Recipient</label>
                    <typeaheadRecipients 
                        fieldName="recipient" 
                        source="/api/benefits/recipients?grouptype="
                        v-bind:grouptype="grouptype"
                        placeholder="Please start typing recipients name"
                        v-on:recipient="saveRecipient">
                        </typeaheadRecipients><br/>

                    <label>Provider</label>
                    <typeaheadProviders
                        fieldName="provider"
                        source="/api/benefits/providers?grouptype="
                        v-bind:grouptype="grouptype"
                        placeholder="Please start typing providers name"
                        v-on:provider="saveProvider">
                        </typeaheadProviders><br/>


<!--
 					<label>Recipient</label>
                    <autocompleteRecipients :recipients="recipients" v-model="queryRecipients"></autocompleteRecipients><br/>
 -->                    
<!-- 					<label>Provider</label><autocompleteProviders :providers="providers" v-model="queryProviders"></autocompleteProviders><br/>  -->

					<div class="sliderSection"><label>Amount</label> <small>(${{valueAmount[0]}} - ${{valueAmount[1]}})</small>
						<vue-slider ref="amountSlider" v-model="valueAmount" v-bind="optionsAmount"></vue-slider>
					</div>

					<div class="sliderSection"><label>Year</label>
						<vue-slider @callback="cb" ref="slider" v-model="valueYear" v-bind="optionsYear"></vue-slider>
					</div>

				</div>

				<div class="summary">
					<small class="rowCount">Showing <b>{{ filteredItems.length }}</b> records
                    <template v-if="valueYear[0] == valueYear[1]">
                        <label>in <strong>{{ valueYear[0] }}</strong></label>
                    </template>
                    <template v-else>
                        <label>between <strong>{{ valueYear[0] }} - {{ valueYear[1] }}</strong></label>
                    </template>
					</small>
				</div>

				<table id="results-table" class="rtable rtable--flip">
					<thead>
						<tr>
							<th class="recipient">Recipient</th>
							<th class="description">Description and Provider</th>
							<th class="received">Received</th>
							<th class="value">Value</th>
							<th class="accepted">Accepted</th>
						</tr>
					</thead>
					<tbody>
						<!-- v-if="!queryProviders || benefit.from == 'Linnie Prohaska'" -->
						<tr v-for="benefit in filteredItems">
							<td class="recipient">{{ benefit.name }}</td>
							<td class="description">{{ benefit.description }}<br><small>{{ benefit.from }}</small></td>
							<td class="received">{{ benefit.received }}</td>
							<td class="value">${{ benefit.value }}</td>
							<td class="accepted">
								<span class="icon is-small is-left">
								<i class="fa fa-check" v-if="benefit.accepted ==1"></i>
                                <i class="fa fa-times" v-else=""></i>
                                
								</span>
							</td>
						</tr>
					</tbody>
				</table>

			</div>
		</section>

	</div>

</template>

<script>

    import typeaheadRecipients from './Typeahead-Recipients.vue';
    import typeaheadProviders from './Typeahead-Providers.vue';

    export default {

        components: {
          typeaheadRecipients,
          typeaheadProviders
        },

        data() {
            return {
                items: [],
                itemCount: 0,
                //maxAmount: 1000,
                recipient: '',
                recipients: [],
                queryRecipients: '',
                filterRecipients: [],
                providers: [],
                queryProviders: '',
                filterProviders: [],
                loading: false,
                error: false,
                selection: '',
                valueAmount: [ 10, 20 ],
                valueYear: [0,0],
                optionsAmount: {
                    min: 0,
                    max: 1000,
                    formatter: '${value}',
                    interval: 10,
                    tooltipDir: 'bottom'
                },
                optionsYear: {
                    tooltipDir: 'bottom',
                    piecewise: true,
                    piecewiseLabel: true,
                    data: []
                }
            }
        },

        props: {
            index: { default: 0 },
            grouptype: {}
        },

        mounted() {

            this.getVueItems()

            this.getMaxAmount()
            this.getYearRange()

            // this.searchRecipients()       
            // this.searchProviders()
            //alert(this.amountMin)
        },

        computed: {
            filteredItems() {
                return this.items
                    .filter(item => {
                        return item.name.toLowerCase().indexOf(this.queryRecipients.toLowerCase()) > -1
                    })
                    .filter(item => {
                        return item.from.toLowerCase().indexOf(this.queryProviders.toLowerCase()) > -1
                    })
                    .filter(item => {
                        return item.value >= this.valueAmount[0] && item.value <= this.valueAmount[1]
                    })
                    .filter(item => {
                        return item.received.substring(0,4) >= this.valueYear[0] && item.received.substring(0,4) <= this.valueYear[1]
                    })
            }
        },

        methods: {

            reload() {
                //this.getVueItems()
                this.getMaxAmount()
                this.getYearRange()
            },

            saveRecipient(value) {
                this.queryRecipients = value;
            },
            saveProvider(value) {
                this.queryProviders = value;
            },

            getVueItems: function() {
                axios.get('/api/benefits', {params: {grouptype: this.grouptype}} )
                    .then(response => {
                        this.items = response.data;
                    });
            },
            getMaxAmount: function() {
                axios.get('/api/benefits/maxAmount', {params: {grouptype: this.grouptype}} )
                    .then(response => { 
                        this.optionsAmount.max = response.data.value;
                        this.valueAmount = [0,response.data.value];
                    });  
            },
            setIndex(name, num) {
                let slider = this.$refs[name];
                slider.setIndex(num);
                slider.refresh;
            },
            cb (val) {
                //console.log(val)
            },
            getYearRange: function() {
                axios.get('/api/benefits/yearRange', {params: {grouptype: this.grouptype}} )
                    .then(response => { 
                        this.optionsYear.data = response.data;
                        if(this.optionsYear.data.length===1) {
                            this.valueYear = [this.optionsYear.data[this.optionsYear.data.length -1], this.optionsYear.data[this.optionsYear.data.length -1]]    
                        } else if(this.optionsYear.data.length===2) {
                            this.valueYear = [this.optionsYear.data[this.optionsYear.data.length -2], this.optionsYear.data[this.optionsYear.data.length -1]]
                        } else {
                            this.valueYear = [this.optionsYear.data[this.optionsYear.data.length -3], this.optionsYear.data[this.optionsYear.data.length -1]]
                        }
                        
                    });  
            },
            // searchRecipients: function() {
            //     this.error = '';
            //     this.recipients = [];
            //     this.loading = true;
            //     axios.get('/api/benefits/recipients', {params: {grouptype: this.grouptype, q: this.queryRecipients} })
            //         .then(response => { 
            //             //console.log(response);
            //             response.data.error ? this.error = response.data.error : this.recipients = response.data;
            //             this.loading = false;
            //             //this.queryRecipients = '';
            //         });
            // },
            addRecipient: function(index, val) {
                this.queryRecipients = val;
                this.filterRecipients.push(val);
                this.recipients.splice(index, 1);
            },
            removeRecipient: function(index, r) {
                this.filterRecipients.splice(index, 1);
            },
            // searchProviders: function() {
            //     this.error = '';
            //     this.providers = [];
            //     this.loading = true;
            //     axios.get('/api/benefits/providers', {params: {grouptype: this.grouptype, q: this.queryProviders} })
            //         .then(response => { 
            //             //console.log(response);
            //             response.data.error ? this.error = response.data.error : this.providers = response.data;
            //             this.loading = false;
            //             //this.queryProviders. = '';
            //         });
            // },
            addProvider: function(index, val) {
                this.queryProviders = val;
                this.filterProviders.push(val);
                this.providers.splice(index, 1);
            }
        }        

    }

</script>



// WEBPACK FOOTER //
// Modules/Register/Resources/assets/js/components/Benefits.vue